module.exports = __webpack_public_path__ + "static/media/header.3691cfe6.mp3";